import React, { Component } from "react";
import { connect } from "react-redux";
import Groups from "../../../ducks/Groups";
import TelcoSite from "../../../ducks/TelcoSite";
import { bindActionCreators } from "redux";
import classnames from "classnames";
import CheckboxListComponent from "../../common/CheckboxListComponent";
import { CheckboxInlineComponent } from "../../common/CheckboxListComponent";
import TextFieldGroup from "../../common/TextFieldGroup";
import TextAreaGroup from "../../common/TextAreaGroup";
import GeoFenceMap from "../../common/maps/geofence";
import "../index.css";
import { validateSiteInput } from "../../../validations/geofence";
import { WhiteSpinner, Spinner } from "../../common/Spinner/index";
import Slider from "rc-slider";
import { HandleSlider } from "../../common/HandleSlider";
import UpdateMap from "./updateMap";

import * as _ from "lodash";

import toastr from "toastr";

class UpdateTelcoSite extends Component {
    constructor() {
        super();
        this.state = {
            sites: [],
            name: "",
            description: "",
            center: 0,
            radius: 0,
            errors: {},
            loader: false,
        };
    }




    async componentDidMount() {
        await this.props.telcoActions.getSingleSite({
            id: this.props.match.params.id,
        });


        this.setState({
            ...this.state,
            name: this.props.site.name,
            description: this.props.site.description,
            center: this.props.site.center,
            radius: this.props.site.radius,

        });
    }
    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
            errors: { ...this.state.errors, [e.target.name]: "" },
        });
    }


    onMapChange = (circle) => {
        let radius = circle.getRadius();
        radius = Math.round(radius);

        this.setState({
            ...this.state,
            center: [circle.getCenter().lng(), circle.getCenter().lat()],
            radius,
        });

        return {
            center: [circle.getCenter().lng(), circle.getCenter().lat()],
            radius,
        };
    };


    isValid = () => {
        const { errors, isValid } = validateSiteInput(this.state);

        if (!isValid) {
            this.setState({ errors });
        }
        return isValid;
    };
    onSubmit = async (e) => {
       
        e.preventDefault();
        if (this.isValid()) {
            try {
                const state = this.state;
                this.setState({
                    ...this.state,
                    loader: true,
                });
                let siteObj = {
                    name: _.trim(state.name),
                    description: _.trim(state.description),
                    alerts: {
                        ENTRY: true,
                        EXIT: true,
                    },
                    center: state.center,
                    radius: state.radius
                };

                await this.props.telcoActions.UpdateSite({
                    siteObj,
                    id: this.props.match.params.id,
                });
                toastr.success("Site Updated Successfully!");
                this.setState({
                    ...this.state,
                    loader: false,
                });
                this.props.history.push(`/telcoTable`);
            } catch (err) {
                console.log("dnjwed" , err)
                this.setState({
                    ...this.state,
                    loader: false,
                });
                toastr.error(err.response.data.message);
            }
        }
        else {
        }
    };


    render() {
        const {
            name,
            description,
        } = this.state;
        const loader = <WhiteSpinner key="1" />;
        const loader1 = <Spinner key="2" />;

        return (
            <div>
                {console.log("dhiuewjdoi")}
                {this.props.isLoading ? (
                    [loader1]
                ) : (
                    <form onSubmit={this.onSubmit}>
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-4">
                                <TextFieldGroup
                                    onChange={this.onChange.bind(this)}
                                    value={name}
                                    label={"Site Name*"}
                                    type={"text"}
                                    field={"name"}
                                    error={this.state.errors.name}
                                    placeholder={"E.g Warehouse, school"}
                                />
                                <TextAreaGroup
                                    onChange={this.onChange.bind(this)}
                                    value={description}
                                    label={"Description"}
                                    field={"description"}
                                    error={this.state.errors.description}
                                    placeholder={"Extra details about site"}
                                />
                                <div className="col padding0">
                                    <div className="margin-btm-50">
                                        <button
                                            className="btn auxo-primary-btn create-geofence-btn"
                                            type="submit"
                                        >
                                            {this.state.loader ? [loader] : "Update"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-8">
                                <UpdateMap
                                    center={{
                                        lat: this.state.center[1],
                                        lng: this.state.center[0],
                                    }}
                                    Center={this.state.center}
                                    geoFences={this.state.geoFences}
                                    radius={200}
                                    onMapChange={this.onMapChange}
                                />

                            </div>
                        </div>
                    </form>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        site: state.telcosites.site,
        isLoading: state.telcosites.isLoading
    };
};

const mapDispatchToProps = (dispatch) => ({
    telcoActions: bindActionCreators(TelcoSite.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(UpdateTelcoSite);
